import { RegionType } from '@wix/shoutout-email-model-v3';
import { hasPlaceholder } from '@wix/wix-emails-placeholders';
import { get } from 'lodash';
import { addHttps } from '../../utils/add-https';
import * as cssUtils from '../../utils/css-utils';
import { getMessageWidth } from '../../utils/get-message-width';
import { getImageSrc, getImageWidth, isGif } from './image-utils';
const AVATAR_SIZE = 60;
export const getImageSection = ({ region, composerData, css, replaceImagePlaceholders, }) => {
    if (region.type !== RegionType.Image) {
        throw Error('Image must be passed');
    }
    const userOverrides = get(region, 'data.styles.region');
    const rules = [
        userOverrides,
        css['so-global-region-image'],
        css['so-global-region'],
    ];
    const visibility = get(region, 'data.visibility');
    const mobileCssClass = cssUtils.getRegionMobileCssClass(rules, true, visibility);
    const padding = cssUtils.padding(rules);
    const margin = cssUtils.margin(rules);
    const containerBackground = cssUtils.containerBackgroundColor(rules);
    const borderWidth = cssUtils.containerBorderWidth(rules);
    const borderStyle = cssUtils.containerBorderStyle(rules);
    const borderColor = cssUtils.containerBorderColor(rules);
    const containerBorder = borderStyle &&
        [borderWidth, borderStyle, borderColor].filter(Boolean).join(' ');
    const messageContentWidth = getMessageWidth(composerData, css);
    const maxWidth = messageContentWidth -
        ((padding.left || 0) + (padding.right || 0)) -
        ((margin.left || 0) + (margin.right || 0));
    const { src, srcRetina } = getImageSrc({
        region,
        fallbackUrl: composerData.styles.settings.image.url,
        maxContentWidth: maxWidth,
        replaceImagePlaceholders,
    });
    // NOTE: This stores probable image dimensions for outlook and loader. They
    // might match rendered image if there is enough information to do it but
    // otherwise it might be wild guess.
    let probableWidth;
    let probableHeight;
    let width;
    const imageProps = {
        outerPadding: margin,
        innerPadding: padding,
    };
    const imgStyle = {};
    if (region.data.placeholderPreviewType === 'avatar') {
        probableWidth = AVATAR_SIZE;
        probableHeight = AVATAR_SIZE;
        width = AVATAR_SIZE.toString();
        imgStyle.borderRadius = '100%';
        imgStyle.height = `${AVATAR_SIZE}px`;
    }
    else {
        probableWidth = getImageWidth(region, maxWidth);
        width = isGif(src) ? probableWidth.toString() : 'auto';
        if (region.data.width && region.data.height) {
            probableHeight = (region.data.height * probableWidth) / region.data.width;
        }
        else {
            probableHeight = Math.floor(probableWidth / 1.6);
        }
    }
    const srcPlaceholder = region.data.relativeUri || region.data.url;
    return {
        src: addHttps(src),
        srcRetina: addHttps(srcRetina),
        srcPlaceholder: hasPlaceholder(srcPlaceholder) ? srcPlaceholder : '',
        link: region.data.imageLink,
        altText: region.data.altText,
        probableWidth,
        probableHeight,
        width,
        cssClass: mobileCssClass,
        ...imageProps,
        imgStyle,
        containerBackground,
        containerBorder,
        visibility,
    };
};
//# sourceMappingURL=get-image-section.js.map